import React from "react";

const QuestionStats = ({ updateUuid, uuid, label, isActive }) => {
    return (
        <>
            <div onClick={() => {
                updateUuid(uuid);
            }} className={`question-stats ${isActive ? "active" : ""}`}>
                {label}              
            </div>
        </>
    );
}

export default QuestionStats;